<template>
  <div class="faqDeliveryTable">
    <div class="faqDeliveryTable__top">
      <div class="faqDeliveryTable__topInner">
        <h2 class="faqDeliveryTable__topTitle">{{ data.Top.Title }}</h2>
        <div class="faqDeliveryTable__topElements">
          <div
            class="faqDeliveryTable__topElement"
            v-for="(item, index) in data.Top.Elements"
            :key="index"
          >
            <div class="faqDeliveryTable__topElementIcon">
              <img
                :src="JSON.parse(item.Icon).url"
                :alt="item.Title"
                class="faqDeliveryTable__topElementIconImg"
              />
            </div>
            <div class="faqDeliveryTable__topElementText">
              <p class="faqDeliveryTable__topElementTextTitle">{{ item.Title }}</p>
              <p class="faqDeliveryTable__topElementTextContent">{{ item.Text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="faqDeliveryTable__content">
      <div class="faqDeliveryTable__contentItem" v-for="(item, index) in data.Content" :key="index">
        <div class="faqDeliveryTable__contentItemQuestion">
          <div class="faqDeliveryTable__contentItemQuestionNumber">{{ index + 1 }}</div>
          <h3 class="faqDeliveryTable__contentItemQuestionText">{{ item.Question }}</h3>
        </div>
        <p class="faqDeliveryTable__contentItemAnswer" v-html="item.Answer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqDeliveryTable',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.faqDeliveryTable {
  background-color: $cWhite;

  &__top {
    padding: 2rem 2rem 2.5rem;

    @include rwd('large-phone') {
      padding: 1.5rem;
    }
  }

  &__topInner {
    padding-bottom: 2.5rem;
    background-color: $cBg;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1006' height='190'%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath data-name='Rectangle 3204' transform='translate(476 1537)' fill='%23f7f8fc' d='M0 0h1006v190H0z'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Cpath data-name='Rectangle 3057' transform='translate(0 18.767)' fill='none' d='M0 0h417.793v251.569H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Mask Group 77' transform='translate(-476 -1537)' clip-path='url(%23a)'%3E%3Cg data-name='Group 23304'%3E%3Cg data-name='Group 22981'%3E%3Cg data-name='Group 22979' transform='translate(1064.208 1518)' clip-path='url(%23b)'%3E%3Cpath data-name='Path 4864' d='M328.44 82.654 231.225-40.873c-11.543-14.664-1.134-36.188 17.527-36.246l174.5-.545-.69 160.318Z' fill='%23eff3ff'/%3E%3Cpath data-name='Path 4865' d='M363.139-61.394 265.924 62.133c-11.543 14.664-1.134 36.185 17.527 36.246l174.5.545-.69-160.318Z' fill='%23fdb57e'/%3E%3Cpath data-name='Path 4866' d='M422.831 202.061 325.62 78.535c-11.543-14.664-1.133-36.188 17.527-36.247l174.5-.545-.69 160.318Z' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3Cg data-name='Group 23288'%3E%3Cg data-name='Group 22979' clip-path='url(%23b)' transform='translate(476 1518)'%3E%3Cpath data-name='Path 4864' d='m89.348 82.654 97.219-123.527c11.543-14.664 1.134-36.188-17.527-36.246l-174.5-.545.69 160.318Z' fill='%23eff3ff'/%3E%3Cpath data-name='Path 4865' d='m54.655-61.394 97.214 123.527c11.543 14.664 1.134 36.185-17.527 36.246l-174.5.545.69-160.318Z' fill='%23fdb57e'/%3E%3Cpath data-name='Path 4866' d='M-5.038 202.061 92.173 78.535c11.543-14.664 1.133-36.188-17.527-36.247l-174.5-.545.69 160.318Z' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-size: 100%;
    background-repeat: no-repeat;

    @include rwd('laptop') {
      background-image: none;
    }

    @include rwd('tablet') {
      padding-bottom: 0;
    }
  }

  &__topTitle {
    padding: 1.5rem 2rem 3rem;
    font-size: 3.6rem;
    font-weight: 600;
    line-height: 4.5rem;
    color: $cMainDark;
    text-align: center;

    @include rwd('laptop') {
      padding-bottom: 1.5rem;
      font-size: 3rem;
      line-height: 3.8rem;
    }

    @include rwd('large-phone') {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__topElements {
    display: flex;
    padding: 0 8rem;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 -1.4rem;

    @include rwd('laptop') {
      padding: 0 3rem;
    }

    @include rwd('small-tablet') {
      margin: 0;
      padding: 0 1.5rem;
    }
  }

  &__topElement {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
    padding: 0 1.4rem;
    display: flex;
    align-items: center;

    @include rwd('tablet') {
      margin-bottom: 2rem;
      flex: 0 0 50%;
      max-width: 50%;
    }

    @include rwd('small-tablet') {
      padding: 0;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__topElementIcon {
    padding-right: 2rem;

    @include rwd('laptop') {
      padding-right: 1rem;
    }

    @include rwd('small-tablet') {
      width: 70px;
    }

    @include rwd('large-phone') {
      width: 60px;
    }
  }

  &__topElementIconImg {
    max-height: 43px;
    height: 100%;
    max-width: 100%;
    width: auto;

    @include rwd('laptop') {
      max-height: 35px;
    }

    @include rwd('large-phone') {
      max-height: 3rem;
    }
  }

  &__topElementText {
    flex: 1;
  }

  &__topElementTextTitle {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 2.1rem;
    color: $cMainDark;

    @include rwd('laptop') {
      font-size: 1.6rem;
      line-height: 2rem;
    }
  }

  &__topElementTextContent {
    margin-top: 0.5rem;
    font-size: 1.5rem;
    line-height: 1.9rem;

    @include rwd('laptop') {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  &__content {
    padding: 0 3rem 3rem;

    @include rwd('large-phone') {
      padding: 0 1.5rem 3rem;
    }
  }

  &__contentItem {
    margin-bottom: 3rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__contentItemQuestion {
    display: flex;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    align-items: center;
    border-bottom: 1px solid $cAddLight;

    @include rwd('laptop') {
      margin-bottom: 1.5rem;
      padding-bottom: 1.5rem;
    }
  }

  &__contentItemQuestionNumber {
    display: flex;
    margin-right: 1.5rem;
    align-items: center;
    justify-content: center;
    flex: 0 0 3.1rem;
    max-width: 3.1rem;
    height: 3.1rem;
    border-radius: 50%;
    border: 1px solid $cAddLight;
    color: $cAddDark;
    font-family: $fSecond;
    font-size: 1.4rem;
    font-weight: 500;

    @include rwd('large-phone') {
      margin-right: 1rem;
    }
  }

  &__contentItemQuestionText {
    font-size: 1.8rem;
    line-height: 2.3rem;

    @include rwd('large-phone') {
      font-size: 1.6rem;
      line-height: 2rem;
    }
  }

  &__contentItemAnswer {
    padding: 0 1.5rem 0 4.6rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $cMainLight;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 2.2rem;
    }

    @include rwd('large-phone') {
      padding: 0 1.5rem;
    }

    ::v-deep {
      p {
        margin-bottom: 1em;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      a {
        color: $cMain;
        text-decoration: underline;
        transition: color $tr;

        &:hover {
          color: $cSec;
        }
      }
    }
  }
}
</style>
